import { render } from "./Principal-UnfinishedCourse.vue?vue&type=template&id=2b31feed"
import script from "./Principal-UnfinishedCourse.vue?vue&type=script&lang=js"
export * from "./Principal-UnfinishedCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__